const DEBUG_FLAGS = new Set(
  new URLSearchParams(window.location.search)
    .getAll('debug')
    .join(',')
    .split(',')
    .map((value) => value.trim().toLowerCase())
    .filter(Boolean)
);

export const isDebugEnabled = (name) =>
  DEBUG_FLAGS.has(name.trim().toLowerCase());
